import React, { useState} from "react";
import { Modal, message,Upload, Button, Typography,Row, notification } from "antd";
import { FileExcelOutlined, WarningOutlined } from "@ant-design/icons";
import { BandejaAprobacionAdministracionPersonalService } from "services/contratos/BandejaAprobacionAdministracionPersonalService";
import { useAtom } from "jotai";
import { FormatoCarga } from "enums/FormatoCarga";

const EXCEL_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const ModalActualizarResponsables = ({visible, setVisible}) => {
    const { Text, Paragraph } = Typography;
    const [listaDocumentos, setListaDocumentos] = useState([]);
    const [loading, setLoading] = useState(false);

    const onClickBtnActualizarResponsables = async () => {
        if (listaDocumentos.name) {
          try {
            setLoading(true);
            const formData = new FormData();
            formData.append("file", listaDocumentos);
            const response = await BandejaAprobacionAdministracionPersonalService.actualizarResponsables(formData);
            const contentType = response.headers["content-type"] || "";

            if (contentType.includes(EXCEL_CONTENT_TYPE) || contentType.includes("spreadsheetml")) {
              const url = window.URL.createObjectURL(new Blob([response.data], { type: EXCEL_CONTENT_TYPE }));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "errores_actualizar_responsables.xlsx");
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);

              notification.warning({
                message: "Proceso completado con errores",
                description: "Algunos registros no pudieron actualizarse. Se descargó un Excel con el detalle de los errores.",
                icon: <WarningOutlined style={{ color: "#faad14" }} />,
                duration: 8,
              });
            } else {
              message.success("La actualización se realizó correctamente");
            }
          } catch (error) {
            notification.error({
              message: "Alerta!",
              description: error?.response?.data?.mensaje || "Ocurrió un error al procesar el archivo. Intente nuevamente.",
            });
          } finally {
            setLoading(false);
            setVisible(false);
          }
        } else {
          message.error("No ha seleccionado el archivo excel");
        }
    };

    const onClickBtnCancelar = () => {
        setVisible(false);
    };

    const props = {
        onRemove: (file) => {
          setListaDocumentos([]);
          borrarDatos();
          return {
            listaDocumentos: [],
          };
        },
        beforeUpload: (file) => {
          if (!FormatoCarga.EXCEL.extension.includes(file.type)) {
            message.error(`${file.name} no es un archivo Excel`);
          } else {
            setListaDocumentos(file);
            return false;
          }
        },
        listaDocumentos,
      };

    function borrarDatos() {
        setListaDocumentos([]);
    }

    return (
        <Modal
            title="Actualizar responsable renovación y/o Administrador"
            open={visible}
            onOk={onClickBtnActualizarResponsables}
            onCancel={onClickBtnCancelar}
            okText="Si, Actualizar!"
            afterClose={borrarDatos}
            destroyOnClose={true}
        >
            <div>
                <Row>
                    <div
                        style={{
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        }}
                    >
                        <Upload {...props} maxCount={1} accept={FormatoCarga.EXCEL.extension}>
                            <Button style={{ borderRadius: 4, borderColor: "green" }} loading={loading}>
                                <FileExcelOutlined style={{ fontSize: 20, color: "green" }} />{" "}
                                <Text style={{ color: "green" }}>Cargar archivo Excel</Text>
                            </Button>
                        </Upload>
                    </div>
                </Row>
            </div>
        </Modal>
    );
};

export default ModalActualizarResponsables;
